export default "__VITE_ASSET__BoORheJK__"